import { DefaultCardDimensions } from "@/appComponents/Blocks/Cards/CardWrapper/CardWrapper";
import { getContainerHeight } from "@/Utils/getContainerSize";

/**
 * Calculate modal dimensions dynamically based on card dimensions and viewport
 * Used by both PositionEditorModal and RecordEditorModal for consistent sizing
 *
 * @returns {Object} Object with initialWidth and initialHeight properties
 */
export const calculateModalSize = () => {
  const cardDimensions = DefaultCardDimensions();
  const initialWidth = 1000;
  const minHeight = 400;
  const modalChromeHeight = 85;
  const bufferForUI = 100;
  const maxModalHeight = getContainerHeight() - bufferForUI;
  const calculatedModalHeight = Math.min(
    cardDimensions.initialHeight + modalChromeHeight,
    maxModalHeight
  );
  const initialHeight = Math.max(minHeight, calculatedModalHeight);

  return { initialWidth, initialHeight };
};
